import React, { useRef, useEffect } from "react";

const Textarea = ({ value, onChange, name, fieldName }) => {
  const textareaRef = useRef(null);

  const heightAdjuster = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust based on content
    }
  };

  useEffect(() => {
    heightAdjuster(); // Adjust on initial render and when value changes
  }, [value]);

  return (
    <>
      {fieldName && (
        <>
          <strong>{fieldName}:</strong>
        </>
      )}
      <textarea
        ref={textareaRef}
        name={name}
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          resize: "none", // Disable manual resizing
        }}
        className="form-control h-100px"
      />
    </>
  );
};

export default Textarea;
